module.exports = __webpack_public_path__ + "static/img/png.2267ff1c.png";